import { all, fork } from "redux-saga/effects";
import AdminSaga from "./AdminSaga";
import CategorySaga from "./CategorySaga";
import PaymentSaga from "./PaymentSaga";

export default function* rootSaga() {
    yield all([
        fork(AdminSaga),
        fork(CategorySaga),
        fork(PaymentSaga),
    ]);
}
